isToAbs